// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"38":"de8ec08f","453":"63834957"}[chunkId] + ".chunk.js";
};